import { Check } from "lucide-react";

const BULLETS = [
  "Remuneração pelo volume que você divulga diretamente aos seus clientes",
  "Comissão competitiva, acima da média do mercado",
  "Sem estrutura de indicação, recrutamento ou downline — não é MLM",
  "Produto que fortalece sua autoridade como especialista",
  "Você escolhe quando, como e para quem oferecer",
];

export const AssessoresComoGeraReceita = () => {
  return (
    <section className="bg-[#FAF8F5] py-16 sm:py-20 md:py-24">
      <div className="container-wide px-6 sm:px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-10 sm:mb-12">
          <span className="inline-flex items-center rounded-full bg-[#34F285]/[0.06] px-4 py-1.5 text-xs font-medium text-[#1F3D2E] ring-1 ring-[#1F3D2E]/10">
            Modelo de ganhos
          </span>
          <h2
            className="mt-6 font-extrabold leading-[1.1] tracking-tight text-[#323F4F] text-3xl sm:text-4xl md:text-5xl"
            style={{ fontFamily: '"Plus Jakarta Sans", Inter, system-ui, sans-serif' }}
          >
            Como você gera receita com a Allu
          </h2>
          <p className="mt-5 text-base sm:text-lg text-zinc-600 leading-relaxed">
            Um modelo transparente e direto, sem promessas exageradas — apenas
            resultados consistentes ligados ao volume que você divulga.
          </p>
        </div>

        <div className="rounded-3xl bg-gradient-to-br from-[#E5F8EC] to-[#F3F8F1] p-3 sm:p-4">
          <div className="grid lg:grid-cols-12 gap-0 items-stretch">
            <div className="lg:col-span-7 p-6 sm:p-9">
              <ul className="space-y-3.5">
                {BULLETS.map((b) => (
                  <li key={b} className="flex items-start gap-3">
                    <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-white flex items-center justify-center">
                      <Check className="w-3 h-3 text-[#2E694D]" />
                    </span>
                    <span className="text-sm sm:text-base text-[#323F4F]/85 leading-relaxed">
                      {b}
                    </span>
                  </li>
                ))}
              </ul>

              <a
                href="#form"
                className="mt-8 inline-flex items-center justify-center gap-2 rounded-2xl bg-[#2E694D] hover:bg-[#255A41] text-[#FAFAFA] text-sm font-medium px-[18px] py-3.5 transition-colors"
              >
                Quero ser parceiro
              </a>
            </div>

            <div className="lg:col-span-5 relative rounded-2xl overflow-hidden bg-[#112711] min-h-[220px] p-6 sm:p-8 flex flex-col justify-center">
              <span className="inline-flex items-center gap-1.5 self-start rounded-full bg-white/10 px-3 py-1 text-[10px] font-semibold tracking-[0.1em] uppercase text-[#D9BC7C]">
                Regulamentado pela CVM
              </span>

              <div className="mt-6 space-y-4 divide-y divide-white/10">
                {[
                  { label: "Emissor", value: "Cia. Securitizadora Allu Invest S.A." },
                  { label: "Divulgação", value: "Dexcap Investimentos (CVM 88)" },
                  { label: "Lastro", value: "Aluguel de eletrônicos por assinatura" },
                ].map((row) => (
                  <div key={row.label} className="pt-4 first:pt-0">
                    <div className="text-[11px] font-semibold tracking-[0.1em] uppercase text-white/45">
                      {row.label}
                    </div>
                    <div className="mt-1 text-sm font-semibold text-white">
                      {row.value}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
